// Utilidades para el RUT chileno: limpieza, formateo y validación del dígito
// verificador con el algoritmo módulo 11.

/**
 * Deja solo números y la K (en mayúscula). Quita puntos, guiones y espacios.
 */
export function limpiarRut(rut) {
  return (rut || '')
    .toString()
    .replace(/[^0-9kK]/g, '')
    .toUpperCase();
}

/**
 * Calcula el dígito verificador que corresponde a un cuerpo numérico de RUT.
 * @param {string} cuerpo - solo los números, sin dígito verificador
 * @returns {string} '0'-'9' o 'K'
 */
export function calcularDigitoVerificador(cuerpo) {
  let suma = 0;
  let multiplo = 2;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo[i], 10) * multiplo;
    multiplo = multiplo === 7 ? 2 : multiplo + 1;
  }
  const resto = 11 - (suma % 11);
  if (resto === 11) return '0';
  if (resto === 10) return 'K';
  return resto.toString();
}

/**
 * Valida un RUT chileno completo (cuerpo + dígito verificador).
 * Acepta el RUT con o sin puntos y guión.
 * @returns {boolean}
 */
export function validarRut(rut) {
  const limpio = limpiarRut(rut);
  if (limpio.length < 2) return false;

  const cuerpo = limpio.slice(0, -1);
  const dv = limpio.slice(-1);

  // El cuerpo debe ser numérico (la K solo puede ir en el dígito verificador)
  if (!/^\d+$/.test(cuerpo)) return false;

  return calcularDigitoVerificador(cuerpo) === dv;
}

/**
 * Formatea un RUT con puntos y guión: "12345678-9" -> "12.345.678-9".
 * Útil para mostrar mientras el usuario escribe.
 */
export function formatearRut(rut) {
  const limpio = limpiarRut(rut);
  if (limpio.length === 0) return '';
  if (limpio.length === 1) return limpio;

  const cuerpo = limpio.slice(0, -1);
  const dv = limpio.slice(-1);

  // Agregar puntos cada 3 dígitos desde la derecha del cuerpo
  const cuerpoConPuntos = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${cuerpoConPuntos}-${dv}`;
}